import styled from '@emotion/styled';
import ButtonBase from '@/components/ButtonBase';

const ButtonWrapper = styled(ButtonBase)({
  textAlign: 'center',
});

export default ButtonWrapper;
